import './index.scss'
import React from 'react'
import { connect } from 'react-redux'
import { userHasPro } from '../../../../lib/util'
import { openModal } from '../../../../action/positioned-modal-state'
import MyContentIcon from '../../../../../asset/Saved_Icon.png'
import MyContentIconWhite from '../../../../../asset/Saved_Icon_white.png'
import MapTools from '../../../../../asset/Plus_Med_icon.png'
import MapToolsWhite from '../../../../../asset/Plus_Med_white.png'
import SettingIcon from '../../../../../asset/Gear_Solid_Grey.png'
import SettingIconWhite from '../../../../../asset/setting_white.png'
import ProIcon from '../../../../../asset/pro-icon.png'
import layerGrey from '../../../../../asset/layer-icon-grey.png'
import layerWhite from '../../../../../asset/layers-icon-white.png'

class IconBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIconMouse: null,
      screenWidth: window.innerWidth,
      userImage: '../../../../asset/default-profile.png'
    };
  }

  handleIconHover = (iconType) => {
    this.setState({ selectedIconMouse: iconType });
  };

  componentDidMount() {
    this.getProfileImage(this.props.user.imageProfileUrl)
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ screenWidth: window.innerWidth });
  };


  getProfileImage = (imageProfileUrl) => {
    let userImage;
    const img = new Image();
    img.src = imageProfileUrl;
    img.onload = () => {
      userImage = img.src;
      this.setState({ userImage });
    };
    img.onerror = () => {
      userImage = '../../../../asset/default-profile.png';
      this.setState({ userImage });
    };
  }

  render() {
    const { selectedIconMouse } = this.state
    const { leftToolbarState, selectIcon, user, openModal } = this.props,
      selectedIcon = leftToolbarState.dialog;
    return (
      <div className='left-icon-bar'>
        <div className='left-icon-bar-logo'></div>
        <div className='left-icon-bar-icon'
          onClick={() => {
            // if (this.props.selectedTab != "huntplanner") {
            const selected = selectedIcon !== 'search' ? 'search' : null
            selectIcon({ dialog: selected })
            // }
          }}
          onMouseOver={() => { this.handleIconHover('searchWhite') }}
          onMouseOut={() => this.handleIconHover('searchGrey')}
        >
          <img
            className='left-icon-bar-image'
            src={
              selectedIcon === 'search'
                ? '../../../../../asset/Search_Solid_white_ldpi.png'
                : selectedIconMouse === 'searchWhite'
                  ? '../../../../../asset/Search_Solid_white_ldpi.png'
                  : selectedIconMouse === 'searchGrey'
                    ? '../../../../../asset/Search_Solid_4F4F4F_ldpi.png'
                    : '../../../../../asset/Search_Solid_4F4F4F_ldpi.png'
            }
          />
          <p className={`left-icon-bar-label ${selectedIcon === 'search' ? 'color-white' : ''}`}>Search</p>
        </div>
        <div className='left-icon-bar-icon' onClick={() => {
          const selected = selectedIcon !== 'layers' ? 'layers' : null
          selectIcon({ dialog: selected })
        }}
          onMouseOver={() => this.handleIconHover('leyerWhite')}
          onMouseOut={() => this.handleIconHover('layerGrey')}
        >
          <img className='left-icon-bar-image' src={
            selectedIcon === 'layers'
              ? layerWhite :
              selectedIconMouse === 'leyerWhite'
                ? layerWhite
                : selectedIconMouse === 'layerGrey'
                  ? layerGrey
                  : layerGrey

          } ></img>
          <p className={`left-icon-bar-label ${selectedIcon === 'layers' ? 'color-white' : ''}`}>Map Layers</p>

        </div>
        <div className='left-icon-bar-icon'
          onClick={() => {
            // const selected = selectedIcon !== 'tools' ? 'tools' : null
            // selectIcon({ dialog: selected })


            if (this.props.selectedTab == "map") {
              const selected = selectedIcon !== 'tools' ? 'tools' : null;
              selectIcon({ dialog: selected });
            }
          }}

          onMouseOver={() => { this.props.selectedTab == "map" && this.handleIconHover('ToolsIconWhite') }}
          onMouseOut={() => this.handleIconHover('ToolsIcon')}>

          <img className='left-icon-bar-image' src={
            selectedIcon === 'tools'
              ? MapToolsWhite :
              selectedIconMouse === 'ToolsIconWhite'
                ? MapToolsWhite
                : selectedIconMouse === 'ToolsIcon'
                  ? MapTools
                  : MapTools

          } ></img>
          <p className={`${this.props.selectedTab == "map" ? 'left-icon-bar-label' : 'left-icon-bar-label-no-hover'} ${selectedIcon === 'tools' && this.props.selectedTab == "map" ? 'color-white' : ''}`}>Map Tools</p>
        </div>
        <div className={`left-icon-bar-icon ${selectedIcon === 'myContent' ? 'color-white' : ''}`}
          onClick={() => {
            if (this.props.selectedTab == "map") {
              this.setState({ selectedIconMouse: null })
              const selected = selectedIcon !== 'myContent' ? 'myContent' : null
              selectIcon({ dialog: selected })
            }
          }}
          onMouseOver={() => { this.props.selectedTab == "map" && this.handleIconHover('MyContentIconWhite') }}
          onMouseOut={() => this.handleIconHover('MyContentIcon')}
        >
          <img className='left-icon-bar-image' src={
            selectedIcon === 'myContent'
              ? MyContentIconWhite :
              selectedIconMouse === 'MyContentIconWhite'
                ? MyContentIconWhite
                : selectedIconMouse === 'MyContentIcon'
                  ? MyContentIcon
                  : MyContentIcon
          }></img>
          <p style={{}}
            className={`${this.props.selectedTab == "map" ? 'left-icon-bar-label' : 'left-icon-bar-label-no-hover'} ${selectedIcon === 'myContent' && this.props.selectedTab == "map" ? 'color-white' : ''}`}>My Content</p>
        </div>

        {this.state.screenWidth > 900 &&
          <>
            <div className='left-icon-bar-icon' style={{ cursor: 'auto' }}></div>
            <div className='left-icon-bar-icon' style={{ cursor: 'auto' }}></div>
          </>
        }

        <div className='left-icon-bar-icon'
          onClick={() => {
            const selected = selectedIcon !== 'settings' ? 'settings' : null
            selectIcon({ dialog: selected })
          }}
          onMouseOver={() => this.handleIconHover('SettingsIconWhite')}
          onMouseOut={() => this.handleIconHover('SettingsIcon')}
        >
          <img className='left-icon-bar-image' src={
            selectedIcon === 'settings'
              ? SettingIconWhite :
              selectedIconMouse === 'SettingsIconWhite'
                ? SettingIconWhite
                : selectedIconMouse === 'SettingsIcon'
                  ? SettingIcon
                  : SettingIcon
          }></img>
          <p className={`left-icon-bar-label ${selectedIcon === 'settings' ? 'color-white' : ''}`}>Settings</p>
        </div>

        <div className='left-icon-bar-icon profile-icon-style'>
          {user.isPro && <img className='is-pro-icon' src={ProIcon}></img>}
          <div className={selectedIcon !== 'profile' ? 'left-toolbar-profile-icon' : 'left-toolbar-profile-icon-white'}
            onClick={() => {
              const selected = selectedIcon !== 'profile' ? 'profile' : null
              selectIcon({ dialog: selected })
            }}
          >
            <img className={'left-icon-bar-profile-image'}
              src={this.state.userImage}
            ></img>
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  leftToolbarState: state.leftToolbarState,
  selectedTab: state.selectedTab
})

const mapDispatchToProps = dispatch => ({
  openModal: data => dispatch(openModal(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(IconBar)